import React from "react";
import {Table} from "antd";
import PropTypes from 'prop-types';

import EditableRow from "./EditableRow";
import EditableCell from "./EditableCell";

import './style.less';

class EditableTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        };
    }

    // Replace existing distance entry with new data
    handleSave = row => {
        const newData = [...this.state.data];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });

        this.setState({data: newData});

        this.props.updateDistanceData(newData);
    };

    getColumns = () => {
        return this.props.columns.map(col => {
            if (!col.editable) {
                return col;
            }

            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    displayName: col.displayName,
                    handleSave: this.handleSave,
                }),
            };
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.setState({data: this.props.data});
        }
    }

    render() {
        const components = {
            body: {
                row: EditableRow,
                cell: EditableCell,
            },
        };
        const columns = this.getColumns();

        return (
            <Table
                scroll={{x: 1130, y: 2000}}     // y value is a placeholder to make empty table look reasonable
                components={components}
                rowClassName='editable-row'
                dataSource={this.state.data}
                columns={columns}
                pagination={this.props.pagination}
            />
        );
    }
}

EditableTable.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.object,
            ]).isRequired,
            dataIndex: PropTypes.string.isRequired,
            width: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            editable: PropTypes.bool,
        })
    ),
    data: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
        })
    ),
    updateDistanceData: PropTypes.func.isRequired,
    pagination: PropTypes.object.isRequired,
};

export default EditableTable;
